import React from "react";

const MessageData = ({ currentLead, htmlMessage }) => {
	const formattedMessage = htmlMessage.replace(/\n/g, "<br />");
	return <div dangerouslySetInnerHTML={{ __html: formattedMessage }} />;
};

export default MessageData;
